export enum AdViewType {
  HPA = 'hpa',
  MOBILE = 'mobile',
  SITEBAR = 'sitebar',
  BILLBOARD = 'billboard',
}

export enum GlobalPayout {
  NONE = 'none',
  PAYOUT_ON_LINKOUT = 'payoutOnLinkout',
  NO_PAYOUT_ON_HOVER = 'noPayoutOnHover',
}
